/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-28 10:05:57
 * @LastEditTime: 2022-03-03 11:27:54
 */
// 报警方式
import i18n from "../common/lang";
export const modeObj = {
  '1': i18n.t('lang.alarmContact.email'),
  '4': i18n.t('lang.alarmContact.wechat'),
  '5': i18n.t('lang.alarmContact.wechat'),
  '2': i18n.t('lang.alarmContact.Shortmessage'),
  '3': `${i18n.t('lang.alarmContact.Shortmessage')}、${i18n.t('lang.alarmContact.email')}`,
  '6': `${i18n.t('lang.alarmContact.Shortmessage')}、${i18n.t('lang.alarmContact.wechat')}`,
  '7': `${i18n.t('lang.alarmContact.Shortmessage')}、${i18n.t('lang.alarmContact.wechat')}、i18n.t('lang.alarmContact.email')`
}

// export const modeOptions = [
//   { label: '邮箱', value: 1},
//   { label: '微信', value: 2},
//   { label: '短信', value: 4},
//   { label: '微信、邮箱', value: 3},
//   { label: '短信、邮箱', value: 5},
//   { label: '短信、微信', value: 6},
//   { label: '短信、微信、邮箱', value: 7},
// ]
// 推送机制
export const pushModeObj = {
  '1': i18n.t('lang.alarmNotice.once'),
  '2': i18n.t('lang.alarmNotice.repeatedly')
}
export const pushModeOptions = [
  { label: i18n.t('lang.alarmNotice.once'), value: 1 },
  { label: i18n.t('lang.alarmNotice.repeatedly'), value: 2 },
]